import React from 'react';
import { personalInfo } from '../data';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <h1 className="hero-name">{personalInfo.name}</h1>
      <p className="hero-title">{personalInfo.title}</p>
      <p className="hero-description">{personalInfo.description}</p>
      <div className="hero-buttons">
        <a href={`mailto:${personalInfo.email}`} className="btn btn-primary">
          Get in Touch
        </a>
      </div>
    </section>
  );
};

export default Hero;
